import domSelector from 'src/utils/domSelector';
import clickTracker from 'src/utils/events/clickEvent/clickTracker';

export default () => {
  clickTracker.initialize(domSelector.getLoginButton());
  clickTracker.initialize(domSelector.getRegisterButton());
  clickTracker.initialize(domSelector.getNavbarLogo());
};
